export default "__VITE_ASSET__C$Fbbvzw__"